import { render, staticRenderFns } from "./NhlSavedLineup.vue?vue&type=template&id=56a974e1&scoped=true"
import script from "./NhlSavedLineup.vue?vue&type=script&lang=js"
export * from "./NhlSavedLineup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a974e1",
  null
  
)

export default component.exports